import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import LoadingOverlay from 'react-loading-overlay';
import { FaSignal, FaChartLine, FaListAlt, FaCheckCircle, FaMobileAlt, FaQuestion } from 'react-icons/fa';
import {BmiController} from '../controllers/Bmi';
import BmiResults from './BmiResults';
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Input,
//   Label
// } from "reactstrap";
// import '../styles/bmi.css';


export const BmiForm  = class Form extends Component {
  constructor() {
    super();
    this.state = {
      weight: '',
      height: '',
      loading: false,
      response: {
        error: null,
        warning: null,
        problem: null,
        message: null,
        success: false,
      }
    };
  }

  // Fetch stored user data
//   getUserData = () => {
//     UserController.setData().then((success) => {
//       if(success){
//         UserController.getData().then((userInfo) => {
//           this.setState({User: userInfo.user, Child: userInfo.child});
//         }).catch((error) => {
//             alert(error);
//         });
//       }else{
//         alert("Invalid Login");
//       }
//     }).catch((error) => {
//       alert(error);
//     });
  
// };
//END Fetch stored user data


  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onSubmit = (e) => {
    e.preventDefault();
    const state = this.state;
    state.loading = true;
    this.setState(state);
    const { weight, height } = state;
    BmiController.create(
      {
        weight: weight,
        height: height
      },
      this.props.Child,
      this.props.User,
      this.props.age,
      this.props.Translator
    ).then((res) => {
      // alert(response);
      if(!res.success){
        state.response.error = res.error;
        state.response.warning = null;
        state.response.message = null;
        state.response.success = false;
        state.loading = false;
        this.setState(state);
      }
      else{
        if(res.found_problem){
          // response.warning = "Problem: "+res.warning_problem;
          state.response.warning = res.growth_problem_message;
          state.response.problem = res.growth_problem;
          state.response.message = null;
          state.response.error = null;
          state.response.success = true;
          state.loading = false;
          this.setState(state);
        }
        else{
          state.response.message= res.growth_message;
          state.response.warning = null;
          state.response.problem = null;
          state.response.error = null;
          state.response.success = true;
          state.loading = false;
          this.setState(state);
        }
        // response.warning = "Succeeded: "+res.insertID;
        // response.error = null;
        // this.setState({response});
      }
    }).catch((error) => {
        alert(error);
    });

    this.setState({
      weight: '',
      height: ''
    });

      // alert(response);
      // this.props.history.push("/")
  }

  componentDidMount() {
    // this.getUserData();
  }

  render() {
    const { weight, height, loading } = this.state;
    const { success, message, warning, problem } = this.state.response;
    return (
      <LoadingOverlay active={loading} spinner text='Calculating...'>
        <div className = "bmi-form-div" style = {{height: "auto"}}>
          <div className = "bmi-container">
            {/* <div className = "container-fluid" style={{height: "auto",backgroundColor: "#fff",padding: "0px",paddingBottom: "20px"}}> */}
            <div className = "row">
              <div className ="col-md-3 col-sm-3 col-xs-6 "></div>
              <div className ="col-md-12 col-sm-12 col-xs-12">
                <div className="card text-center" style ={{border: "0"}}>
                <center id="message"><div class="alert-success">{ReactHtmlParser(message)}</div></center>
                {message !== null ? (
                <div className="row" id="message_not_null">
                  <div className="col-12 col-md-12 col-sm-12">
                  <div className="" style={{paddingTop: "10px"}}>Bonyeza ENDELEA ili kupata ushauri wa lishe.</div>
                  <div className="text-center" style={{paddingTop: "25px"}}><Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/`}><button  id='tofeedingForm'>ENDELEA</button></Link></div>
                </div></div>) : !success ? (<div>
                  <div className="card-header text-center" style={{paddingTop: "20px", backgroundColor: "#fff", border: "0px"}}><div className="card-title">{this.props.Translator["metrics_form_title"]}<font style= {{fontWeight: "bold"}}> {this.props.Child.first_name} </font></div></div>
                  <div className="card-body" style={{paddingTop: "20px"}}>
                    <form onSubmit={this.onSubmit}>
                      <center style={{fontFamily: "Abel",fontSize: "1em",color: "red"}}>
                        <h4 id="error" className="alert-danger">{this.state.response.error}</h4>
                      </center>
                      <div className="row" style={{paddingTop: "20px"}}>
                        <div className="col-sm-12 col-12 col-md-12">
                          <div className="form-group row">
                            <label className="form-control-label col-4 col-sm-4 col-md-4" style={{textAlign:"right"}}>{this.props.Translator["metrics_weight_label"]}</label>
                              <input required type="text" id="weight" name="weight" value = {weight} onChange={this.onChange} className="col-5 col-sm-5 col-md-5" style={{border: "0px",borderBottom: "1px solid #000",height: "18px",background: "#fff",textAlign: "center",outline: "none"}} />
                              <div className="col-3 col-sm-3 col-md-3" style={{textAlign:"left"}}><input type="radio" name="kg" checked /><i>kg</i></div>
                          </div>
                        </div>
                      </div>

                      <div className="row" style={{paddingTop: "20px"}}>
                        <div className="col-md-12 col-12 col-sm-12">			
                          <div className="form-group row">
                            <label className="form-control-label col-4 col-sm-4 col-md-4" style={{textAlign:"right"}}>{this.props.Translator["metrics_height_label"]}</label>
                              <input required type="text" id="height" name="height" value = {height} onChange={this.onChange} className="col-5 col-sm-5 col-md-5" style={{border: "0px",borderBottom: "1px solid #000",height: "18px",background: "#fff",textAlign: "center",outline: "none"}} />
                                <div className="col-3 col-sm-3 col-md-3" style={{textAlign:"left"}}><input type="radio" name="cm" checked /><i>cm</i></div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer text-center" style={{paddingTop: "10px", backgroundColor: "#fff", border: "0px"}}>
                      <input type="submit" name="bmi" value={this.props.Translator["metrics_submit_button"]} style={{height: "35px"}} />
                      </div>
                    </form>
                  </div>
                  </div>) : (
                    <BmiResults Translator = {this.props.Translator} message = {message} warning = {warning} problem = {problem} Child = {this.props.Child} />
                  )}
                  </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}

export default BmiForm;